export function ReceiptCancel({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.20499 1.16699H4.79499C2.58999 1.16699 2.04166 1.75616 2.04166 4.10699V10.6753C2.04166 11.2247 2.14842 11.6257 2.33218 11.8652C3.49885 10.6753 4.44872 9.9369 6.41552 7.58366C8.60365 4.96559 9.91552 4.37533 11.6655 2.14029C11.3119 1.39644 10.581 1.16699 9.20499 1.16699ZM6.99885 6.85449H5.24999C5.01082 6.85449 4.81249 6.65616 4.81249 6.41699C4.81249 6.17783 5.01082 5.97949 5.24999 5.97949L7.9108 5.94499C8.14997 5.94499 7.9108 6.17783 7.9108 6.41699C7.9108 6.65616 7.23802 6.85449 6.99885 6.85449ZM9.33332 4.52116H4.66666C4.42749 4.52116 4.22916 4.32283 4.22916 4.08366C4.22916 3.84449 4.42749 3.64616 4.66666 3.64616H9.33332C9.57249 3.64616 9.77082 3.84449 9.77082 4.08366C9.77082 4.32283 9.57249 4.52116 9.33332 4.52116Z"
          fill="#CAD3AB"
        />
        <path
          d="M11.2025 10.6689C11.2025 10.9969 11.1562 11.2072 11.1088 11.3242C11.1049 11.3337 11.0986 11.341 11.0951 11.3486C11.0207 11.316 10.9098 11.2476 10.7689 11.1191L10.6156 10.9678C10.2356 10.5606 9.72281 10.3432 9.19177 10.3721C8.66074 10.401 8.17475 10.6727 7.84119 11.1172L7.84021 11.1182L7.2533 11.9023C7.13771 12.055 7.0385 12.0731 6.99744 12.0732C6.9668 12.0732 6.90246 12.0636 6.82361 11.9941L6.7406 11.9023L6.20544 11.1875L11.2025 6.19043V10.6689Z"
          fill="#CAD3AB"
          stroke="#CAD3AB"
          strokeWidth="1.5"
        />
        <path
          d="M12.8322 1.16699L1.16553 12.8337"
          stroke="#CAD3AB"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
